module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/Phone-54b1a66d56f42c5ea2c83f1e077770bd.png";